export const RATE_TYPE_HOURLY = {
    label: 'Hourly',
    _id: '507f1f77bcf86cd799441013',
    description: 'Hourly rate charged by CMC for service provided',
};
export const RATE_TYPE_FLAT = {
    label: 'Flat',
    _id: '507f1f77bcf86cd799445013',
    description: 'Flat fee charged by CMC for service provided',
};
export const RATE_TYPE_SLIDING_HOURLY = {
    label: 'Sliding Hourly',
    _id: '507f1f77bcf86cd799442013',
    description: 'Hourly rate charged by CMC based on a sliding fee scale',
};
export const RATE_TYPE_TBD = {
    label: 'To Be Decided',
    _id: '507f1f77bcf86cd799446013',
    description: 'Fee not yet decided',
};
export const RATE_TYPE_NO_FEE = {
    label: 'No Fee',
    _id: '507f1f77bcf86cd799444013',
    description: 'No fee charged by CMC for service provided',
};
export const RATE_TYPES = [RATE_TYPE_HOURLY, RATE_TYPE_FLAT, RATE_TYPE_SLIDING_HOURLY, RATE_TYPE_TBD, RATE_TYPE_NO_FEE];
